import "./styles/main.scss";
import "styles/reset/reset.scss";
import "styles/g-grid-v2/g-grid.scss";
import Header from "Dashboard/components/Header";
import Toolbox from "./scenes/Main/components/Toolbox";
import TopSection from "./scenes/Main/components/TopSection";
import TableHeader from "./scenes/Main/components/TableHeader";
import TableFooter from "./scenes/Main/components/TableFooter";
import BottomSection from "./scenes/Financials/components/BottomSection";
import BottomSectionForSalesUnit from "./scenes/Financials/components/BottomSectionForSalesUnit";
import { selectState } from "./scenes/Main/main.slice";
import { useSelector } from "react-redux";

const HighRiseSales = () => {

  const { selectedBuilding } = useSelector(selectState)
  const { selectedSalesUnit } = useSelector(selectState)

  return (
    <>
      <Header title="Gradnja - prodaja" />
      <Toolbox />
      <main id="highRiseSales">
        <section className="loading-container">
          <TableHeader />
          <TopSection />
          <TableFooter />
        </section>
        {(selectedSalesUnit >= 0 && <BottomSectionForSalesUnit />)
          ||
          (selectedBuilding >= 0 && <BottomSection />)
        }
      </main>
    </>
  );
};

export default HighRiseSales;
